import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "margin-top-10"
}
const _hoisted_2 = {
  key: 0,
  class: "margin-top-10"
}
const _hoisted_3 = { class: "font-size-14" }
const _hoisted_4 = { class: "font-size-14" }
const _hoisted_5 = {
  key: 1,
  class: "margin-top-10"
}
const _hoisted_6 = { class: "font-size-14" }
const _hoisted_7 = { class: "font-size-14" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "font-size-14" }
const _hoisted_10 = {
  key: 2,
  class: "margin-top-10"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 3,
  class: "margin-top-10"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "margin-top-10" }
const _hoisted_17 = { class: "font-size-14" }
const _hoisted_18 = {
  key: 4,
  class: "margin-top-10"
}
const _hoisted_19 = { class: "font-size-14" }
const _hoisted_20 = { class: "font-size-14" }
const _hoisted_21 = { class: "font-size-14" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "font-size-14" }
const _hoisted_24 = { class: "font-size-14" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "margin-top-10" }
const _hoisted_27 = { class: "font-size-14" }
const _hoisted_28 = {
  key: 1,
  class: "margin-top-10"
}
const _hoisted_29 = {
  key: 2,
  class: "margin-top-10"
}
const _hoisted_30 = {
  key: 3,
  class: "cron-error text-danger mt-1"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 4,
  class: "margin-top-10"
}
const _hoisted_34 = { class: "font-size-14" }
const _hoisted_35 = {
  key: 5,
  class: "margin-top-10 d-flex align-items-center justify-content-between"
}
const _hoisted_36 = { class: "d-flex align-items-center gap-1" }
const _hoisted_37 = {
  key: 6,
  class: "cron-error text-danger mt-1"
}
const _hoisted_38 = {
  key: 7,
  class: "cron-error text-danger mt-1"
}

import {
  ElSelect,
  ElOption,
  ElRadio,
  ElDatePicker,
  ElInput,
  ElSwitch,
  ElTooltip,
  ElButton,
} from "element-plus";
import { ref, watch, computed, onBeforeMount } from "vue";
import i18n from "@/core/i18n/i18n";
import {
  weekDays,
  resolveSkipIfRunningSetting,
  SKIP_IF_RUNNING_DEFAULT,
} from "@/flow/components/cron-editor/services/cron-editor.service";
import {
  FlowScheduleFieldCapability,
  FlowScheduleModeCapability,
  getFlowScheduleCapabilities,
  normalizeFlowSchedule,
} from "@/flow/services/flow.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'CronEditor',
  props: {
    scheduleType: {},
    schedule: {},
    timeZone: {},
    flowId: {},
    flowVersion: {}
  },
  emits: [
  "update",
  "update-drawer",
  "step-change",
  "schedule-type-change",
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = i18n.global;

const props = __props;

const emit = __emit;

const scheduleTypes = ref<Array<{ value: string; label: string }>>([]);
const scheduleCapabilities = ref<FlowScheduleModeCapability[]>([]);
const recurringScheduleTypes = ref<Set<string>>(new Set());
const scheduleModeByValue = ref<Record<string, string>>({});
const schedulePresets = ref<
  Array<{ value: string; label: string; cronExpression: string }>
>([]);
const dynamicValues = ref<Record<string, unknown>>({});

const scheduleTime = ref("");

const selectedScheduleType = ref();
const selectedScheduleMode = computed(
  () => scheduleModeByValue.value[selectedScheduleType.value] || ""
);
const selectedCapability = computed(() =>
  scheduleCapabilities.value.find(
    (option) => option.value === selectedScheduleType.value
  )
);
const supplementalFields = computed<FlowScheduleFieldCapability[]>(() => {
  const common = new Set(["timeZone", "skipIfRunning"]);
  const handledByMode: Record<string, Set<string>> = {
    none: new Set(),
    predefined: new Set(["startAt", "preset"]),
    one_time: new Set(["startAt"]),
    custom: new Set([
      "startAt",
      "frequency",
      "interval",
      "timeOfDay",
      "dayScope",
      "weekdays",
      "dayOfMonth",
      "ordinal",
      "weekday",
      "monthInterval",
    ]),
    advanced: new Set(["cronExpression"]),
  };
  const handled =
    handledByMode[selectedScheduleMode.value] || new Set<string>();
  return (selectedCapability.value?.fields || []).filter(
    (field) => !common.has(field.name) && !handled.has(field.name)
  );
});

const skipIfRunning = ref(SKIP_IF_RUNNING_DEFAULT);

const skipToggleVisible = computed(() =>
  recurringScheduleTypes.value.has(selectedScheduleType.value)
);

const cronExpression = ref("");

const selectedCron = ref("");
const selectedPreset = ref("");

const propsSet = ref(false);

const types = ref<Array<{ label: string; value: number }>>([]);

const list = ref([
  {
    label: t("Schedule.First"),
    value: 1,
  },
  {
    label: t("Schedule.Second"),
    value: 2,
  },
  {
    label: t("Schedule.Third"),
    value: 3,
  },
  {
    label: t("Schedule.Forth"),
    value: 4,
  },
]);

const selectedType = ref();

const schedule = ref({
  cronExpr: "",
  scheduleTime: null,
  settings: {
    selectedScheduleType: "",
    selectedType: "",
    selectedCron: "",
    data: {},
  },
});

const minValues = ref<number[]>([]);
const normalizationError = ref("");
const capabilitiesError = ref("");
let normalizationTimer: ReturnType<typeof setTimeout> | undefined;
let normalizationRequest = 0;
let pendingNormalization: Promise<void> | undefined;

function createDefaultCronData() {
  return {
    minValue: 1,
    hourlyValue: {
      every: 1,
    },
    startsAt: {
      hour: 12,
      minute: 0,
    },
    weeklyList: [],
    monthlyValue: {
      day: {
        first: 1,
        second: 1,
      },
      the: {
        first: 1,
        second: 1,
        third: 1,
      },
    },
    hourType: "hour-every",
    dayType: "day-every",
    monthType: "month-1",
    day: 0,
    month: 0,
    year: 0,
    hour: 0,
    minutes: 0,
    seconds: 0,
  };
}

const data = ref(createDefaultCronData());

function resetAllScheduleData() {
  scheduleTime.value = null;
  cronExpression.value = "";
  selectedCron.value = "";
  selectedPreset.value = "";
  dynamicValues.value = {};
  selectedType.value = undefined;
  data.value = createDefaultCronData();
  cronExpressionError.value = false;
}

function asIsoDateTime(value: unknown): string | undefined {
  if (!value) return undefined;
  const date = value instanceof Date ? value : new Date(String(value));
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
}

function customFrequency(): string | undefined {
  const frequencyField = selectedCapability.value?.fields.find(
    (field) => field.name === "frequency"
  );
  const option = (frequencyField?.options || []).find(
    (item) => Number(item.editorValue) === Number(selectedType.value)
  );
  return typeof option?.value === "string" ? option.value : undefined;
}

function normalizationValues(): Record<string, unknown> | undefined {
  const mode = selectedScheduleMode.value;
  if (!mode) return undefined;
  const values: Record<string, unknown> = { mode };
  if (mode === "none") return values;

  // Naming the flow lets Java resolve this edit against the schedule already on record, which is
  // what stops it refusing a one-time start that has already fired: this form seeds its date from
  // the saved value and submits it unchanged, so the value arrives as an explicit field.
  //
  // Sent ONLY for that mode. Resolving a flow costs a full load of the flow and its steps plus a
  // Quartz lookup, and this runs on every debounced edit — the other modes submit complete intent
  // and need no baseline, so making them pay for one would be a needless per-keystroke cost.
  if (props.flowId && mode === "one_time") {
    values.flowId = props.flowId;
    if (props.flowVersion !== undefined) values.flowVersion = props.flowVersion;
  }

  values.timeZone =
    props.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const startAt = asIsoDateTime(scheduleTime.value);
  if (startAt) values.startAt = startAt;
  if (mode === "predefined" && selectedPreset.value) {
    values.preset = selectedPreset.value;
  } else if (mode === "advanced") {
    values.cronExpression = cronExpression.value;
  } else if (mode === "custom") {
    const frequency = customFrequency();
    if (frequency) values.frequency = frequency;
    values.timeOfDay = `${String(data.value.startsAt.hour).padStart(
      2,
      "0"
    )}:${String(data.value.startsAt.minute).padStart(2, "0")}`;
    if (frequency === "minute") values.interval = data.value.minValue;
    if (frequency === "hourly") {
      if (data.value.hourType === "hour-every") {
        values.interval = data.value.hourlyValue.every;
        delete values.timeOfDay;
      }
    }
    if (frequency === "daily") {
      values.dayScope =
        {
          "day-every-weekday": "weekday",
          "day-every-weekend": "weekend",
        }[data.value.dayType] || "every";
    }
    if (frequency === "weekly") values.weekdays = data.value.weeklyList;
    if (frequency === "monthly") {
      values.monthInterval =
        data.value.monthType === "month-1"
          ? data.value.monthlyValue.day.second
          : data.value.monthlyValue.the.third;
      if (data.value.monthType === "month-1") {
        values.dayOfMonth = data.value.monthlyValue.day.first;
      } else {
        values.ordinal = data.value.monthlyValue.the.first;
        values.weekday = data.value.monthlyValue.the.second;
      }
    }
  }
  if (recurringScheduleTypes.value.has(selectedScheduleType.value)) {
    const storedSettings = (props.schedule?.settings || {}) as Record<
      string,
      unknown
    >;
    if (
      skipIfRunning.value ||
      Object.prototype.hasOwnProperty.call(storedSettings, "skipIfRunning")
    ) {
      values.skipIfRunning = skipIfRunning.value;
    }
  }
  return { ...values, ...dynamicValues.value };
}

async function applyJavaNormalization() {
  if (!propsSet.value) return;
  const values = normalizationValues();
  if (!values) return;
  const request = ++normalizationRequest;
  try {
    const normalized = await normalizeFlowSchedule(values);
    if (request !== normalizationRequest) return;
    normalizationError.value = "";
    if (normalized.schedule) {
      schedule.value = normalized.schedule;
    }
    // The time zone is a peer of scheduleType/schedule in the normalize result, and it is the
    // zone this schedule was actually built against. The parent must record it: `flow.timeZone`
    // is cleared on every schedule-type change, and `publishFlow` persists the flow without the
    // save-time browser-zone backfill that `onFlowSubmit` applies — so a published draft could
    // keep a schedule normalized in one zone while storing no zone at all.
    emit(
      "update",
      normalized.scheduleType,
      normalized.schedule,
      normalized.timeZone
    );
  } catch (error) {
    if (request !== normalizationRequest) return;
    normalizationError.value =
      error instanceof Error
        ? error.message
        : "The schedule values are invalid.";
  }
}

/**
 * Ask Java to normalize, but ONLY in response to user input.
 *
 * `onStepChange` is the single trigger, so EVERY control bound to schedule state must call it —
 * `@change` for selects/radios/pickers, `@input` for text. Two interval selects were missed when
 * this was introduced, and an edit to them normalized nothing: the editor showed the new interval
 * while a save persisted the old one. `CronEditor.spec.ts` guards both, and the audit is simply
 * "does every `v-model="data.*"` control name a handler?".
 *
 * The value watchers below deliberately do NOT queue: they also fire while the component seeds
 * itself from `props` on mount, and normalizing then rewrote a saved schedule nobody had edited.
 * `FlowServiceImpl.shouldUpdateOrDeleteScheduledJob` compares schedules with `equals()`, so the
 * rewritten settings map — which gains `contractVersion`/`contractValues`/`contractDisplay` —
 * counted as a schedule change and recreated the Quartz job on the next save of that flow.
 */
function queueScheduleNormalization() {
  if (!propsSet.value) return;
  if (normalizationTimer) clearTimeout(normalizationTimer);
  normalizationTimer = setTimeout(runScheduleNormalization, 200);
}

function runScheduleNormalization(): Promise<void> {
  normalizationTimer = undefined;
  pendingNormalization = applyJavaNormalization();
  return pendingNormalization;
}

/**
 * Settle any queued/in-flight normalization and report whether the schedule is valid.
 *
 * Normalization is debounced and asynchronous, so the parent's `flow.schedule` lags the form.
 * Saving inside that window persisted the PREVIOUS schedule while the form showed the new one.
 * The save paths await this first.
 */
async function flushSchedule(): Promise<boolean> {
  if (normalizationTimer) {
    clearTimeout(normalizationTimer);
    runScheduleNormalization();
  }
  await pendingNormalization;
  return !normalizationError.value;
}

__expose({ flushSchedule, scheduleError: normalizationError });

function onFrequencyChange() {
  data.value = createDefaultCronData();
  onStepChange();
}
// No normalization here: the advanced input calls `onStepChange`, while this ref is also
// assigned programmatically (mode switches, preset selection) and while seeding from props.
watch(
  () => cronExpression.value,
  () => undefined
);
function onStepChange() {
  queueScheduleNormalization();
  emit("step-change", true);
}

function onSkipIfRunningChange() {
  const settings = schedule.value.settings as Record<string, unknown>;
  if (skipIfRunning.value) {
    settings.skipIfRunning = true;
  } else {
    delete settings.skipIfRunning;
  }
  onStepChange();
}
// Seeded from props on mount; the date pickers call `onStepChange` for real edits.
watch(
  () => scheduleTime.value,
  () => undefined
);

watch(
  () => [data.value, selectedType.value, selectedScheduleType.value],
  () => {
    if (selectedType.value) {
      schedule.value.settings.selectedType = selectedType.value;
    }
    if (data.value) {
      schedule.value.settings.data = data.value;
    }
    // Bookkeeping only. The custom-schedule controls call `onStepChange`.
  },
  {
    deep: true,
  }
);

watch(
  () => selectedPreset.value,
  () => {
    const preset = schedulePresets.value.find(
      (option) => option.value === selectedPreset.value
    );
    selectedCron.value = preset?.cronExpression || "";
    // No normalization: `syncScheduleTypeCatalog` seeds this from the SAVED cron once
    // capabilities arrive. The preset select calls `onStepChange` for a real choice.
  }
);

watch(
  () => selectedScheduleType.value,
  (newVal, oldVal) => {
    if (!propsSet.value) return;

    const typeChanged = oldVal !== undefined && newVal !== oldVal;

    if (typeChanged) {
      resetAllScheduleData();
      emit("schedule-type-change");
      // Skipping only applies to recurring schedules: crossing the recurring boundary in
      // either direction clears the setting, so it can never linger hidden on a one-time
      // schedule or silently re-arm when switching back to a recurring one.
      if (
        !recurringScheduleTypes.value.has(oldVal) ||
        !recurringScheduleTypes.value.has(newVal)
      ) {
        const settings = schedule.value.settings as Record<string, unknown>;
        delete settings.skipIfRunning;
        skipIfRunning.value = false;
      }
    }

    const newMode = scheduleModeByValue.value[newVal] || "";
    if (newMode === "none") {
      cronExpression.value =
        schedule.value.cronExpr && schedule.value.cronExpr !== "UNDEFINED_CRON"
          ? schedule.value.cronExpr
          : "";
      scheduleTime.value = null;
      selectedCron.value = "";
      schedule.value.settings.selectedScheduleType = "";
      schedule.value.settings.selectedCron = "";
    } else {
      schedule.value.settings.selectedScheduleType = String(newVal);

      if (
        typeChanged &&
        !selectedCron.value &&
        (!schedule?.value.cronExpr ||
          schedule.value.cronExpr === "UNDEFINED_CRON")
      ) {
        cronExpression.value = "";
        schedule.value.settings.selectedCron = "";
      }

      if (
        schedule.value.cronExpr &&
        schedule.value.cronExpr !== "UNDEFINED_CRON"
      ) {
        cronExpression.value = schedule.value.cronExpr;
        schedule.value.settings.selectedCron = schedule.value.cronExpr;
      }

      if (newMode === "predefined" && selectedCron.value) {
        cronExpression.value = selectedCron.value;
        schedule.value.cronExpr = selectedCron.value;
        schedule.value.settings.selectedCron = selectedCron.value;
      }
    }
    // No normalization: this watcher also runs when the mode is seeded from props on mount.
    // The mode select calls `onStepChange`.
  }
);
const cronExpressionError = ref(false);
const errorType = ref<"parts" | "syntax" | undefined>(undefined);

watch(selectedScheduleMode, (newMode) => {
  if (newMode !== "advanced") {
    cronExpressionError.value = false;
  }
});
async function syncScheduleTypeCatalog() {
  try {
    const capabilities = await getFlowScheduleCapabilities();
    const remoteOptions = capabilities.modes;
    scheduleCapabilities.value = remoteOptions;
    scheduleTypes.value = remoteOptions.map(({ value, label }) => ({
      value,
      label,
    }));
    scheduleModeByValue.value = Object.fromEntries(
      remoteOptions.map(({ value, mode }) => [value, mode])
    );
    recurringScheduleTypes.value = new Set(
      remoteOptions
        .filter((option) => option.recurring)
        .map((option) => option.value)
    );
    const predefined = remoteOptions.find(
      (option) => option.mode === "predefined"
    );
    const presetField = predefined?.fields.find(
      (field) => field.name === "preset"
    );
    schedulePresets.value = (presetField?.options || [])
      .filter(
        (option) =>
          typeof option.value === "string" &&
          typeof option.label === "string" &&
          typeof option.cronExpression === "string"
      )
      .map((option) => ({
        value: String(option.value),
        label: String(option.label),
        cronExpression: String(option.cronExpression),
      }));
    const custom = remoteOptions.find((option) => option.mode === "custom");
    const frequencyField = custom?.fields.find(
      (field) => field.name === "frequency"
    );
    types.value = (frequencyField?.options || [])
      .filter(
        (option) =>
          typeof option.label === "string" &&
          Number.isFinite(Number(option.editorValue))
      )
      .map((option) => ({
        label: String(option.label),
        value: Number(option.editorValue),
      }));
    const intervalField = custom?.fields.find(
      (field) => field.name === "interval"
    );
    minValues.value = (intervalField?.allowedValues || [])
      .map(Number)
      .filter(Number.isFinite);
    if (selectedCron.value) {
      selectedPreset.value =
        schedulePresets.value.find(
          (option) => option.cronExpression === selectedCron.value
        )?.value || "";
    }
    capabilitiesError.value = "";
  } catch {
    // Fail closed: do not invent modes, labels, or presets when Java is unavailable. Saying so
    // matters as much as failing closed — an empty drawer with no message reads as "this flow has
    // no schedule options", when in fact the saved schedule is intact and simply cannot be shown.
    capabilitiesError.value = t("Schedule.OptionsUnavailable");
    scheduleTypes.value = [];
    scheduleCapabilities.value = [];
    scheduleModeByValue.value = {};
    recurringScheduleTypes.value = new Set();
    schedulePresets.value = [];
    types.value = [];
    minValues.value = [];
  }
}

watch(
  () => props.timeZone,
  () => queueScheduleNormalization()
);

onBeforeMount(() => {
  if (props.scheduleType !== "SCHEDULED") {
    // WEBHOOK or NONE
    selectedScheduleType.value = "NONE";
  } else if (props.schedule.settings) {
    selectedScheduleType.value = props.schedule.settings.selectedScheduleType;
    selectedCron.value = props.schedule.settings.selectedCron;
    scheduleTime.value = props.schedule.scheduleTime;
    data.value = props.schedule.settings.data;
    selectedType.value = props.schedule.settings.selectedType;
    cronExpression.value = props.schedule.cronExpr;
    const storedSettings = props.schedule.settings as Record<string, unknown>;
    if (Object.prototype.hasOwnProperty.call(storedSettings, "skipIfRunning")) {
      // Preserve the raw stored value: the local schedule object is rebuilt from
      // scratch, and the backend treats any settings-map difference as a schedule
      // change that recreates the Quartz job.
      (schedule.value.settings as Record<string, unknown>).skipIfRunning =
        storedSettings.skipIfRunning;
    }
    skipIfRunning.value = resolveSkipIfRunningSetting(
      storedSettings.skipIfRunning
    );
  }
  propsSet.value = true;
  // AFTER initialization, and deliberately not awaited. Vue ignores a promise returned from a
  // lifecycle hook, so awaiting the catalog fetch here left the component mounted with
  // `propsSet` still false: the `selectedScheduleType` watcher returned early, so a mode the user
  // picked in that window neither reset the schedule data nor emitted `schedule-type-change`, and
  // the initialization below then overwrote their choice when the request resolved.
  syncScheduleTypeCatalog();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(ElSelect), {
      onChange: onStepChange,
      modelValue: selectedScheduleType.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedScheduleType).value = $event)),
      id: "schedule-type-select",
      style: {"width":"100%"},
      size: "small"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheduleTypes.value, (type) => {
          return (_openBlock(), _createBlock(_unref(ElOption), {
            key: type.value,
            value: type.value,
            label: type.label
          }, null, 8, ["value", "label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (selectedScheduleMode.value === 'custom')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(ElDatePicker), {
            onChange: onStepChange,
            size: "small",
            modelValue: scheduleTime.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((scheduleTime).value = $event)),
            type: "datetime",
            style: {"width":"100%"},
            placeholder: _unref(t)('Schedule.FirstTime')
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_unref(ElSelect), {
            onChange: onFrequencyChange,
            modelValue: selectedType.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedType).value = $event)),
            class: "width-100 margin-top-10",
            size: "small",
            placeholder: _unref(t)('Schedule.SelectFrequency'),
            id: "cron-type-select"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (type) => {
                return (_openBlock(), _createBlock(_unref(ElOption), {
                  id: 'type-option-' + type.label,
                  key: type.label,
                  label: type.label,
                  value: type.value
                }, null, 8, ["id", "label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"]),
          (selectedType.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)("Schedule.Every")) + " ", 1),
                _createVNode(_unref(ElSelect), {
                  onChange: onStepChange,
                  modelValue: data.value.minValue,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.minValue) = $event)),
                  id: "minute-select",
                  size: "small",
                  style: {"width":"75px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(minValues.value, (val) => {
                      return (_openBlock(), _createBlock(_unref(ElOption), {
                        id: 'minute-option-' + val,
                        key: val,
                        label: val,
                        value: val
                      }, null, 8, ["id", "label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createTextVNode("  "),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("Schedule.Minute")), 1)
              ]))
            : _createCommentVNode("", true),
          (selectedType.value === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(ElRadio), {
                  onChange: onStepChange,
                  modelValue: data.value.hourType,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.hourType) = $event)),
                  label: "hour-every",
                  id: "hour-type-1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("Schedule.Every")) + " ", 1),
                    _createVNode(_unref(ElSelect), {
                      onChange: onStepChange,
                      modelValue: data.value.hourlyValue.every,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.hourlyValue.every) = $event)),
                      id: "hour-interval-select",
                      size: "small",
                      style: {"width":"75px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (val) => {
                          return _createVNode(_unref(ElOption), {
                            key: val,
                            label: val,
                            value: val
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createTextVNode("  "),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("Schedule.Hour")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_8,
                _createVNode(_unref(ElRadio), {
                  onChange: onStepChange,
                  modelValue: data.value.hourType,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.value.hourType) = $event)),
                  id: "hour-type-2",
                  label: "hour-every-time"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("Schedule.StartsAt")) + "  ", 1),
                    _createVNode(_unref(ElSelect), {
                      onChange: onStepChange,
                      modelValue: data.value.startsAt.hour,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.value.startsAt.hour) = $event)),
                      size: "small",
                      id: "hour-time-select",
                      style: {"width":"75px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElOption), {
                          label: '00',
                          value: 0,
                          id: "hour-option-0"
                        }),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(23, (val) => {
                          return _createVNode(_unref(ElOption), {
                            id: 'hour-option-' + val,
                            key: val,
                            label: val < 10 ? '0' + val : val,
                            value: val
                          }, null, 8, ["id", "label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createTextVNode(" : "),
                    _createVNode(_unref(ElSelect), {
                      onChange: onStepChange,
                      modelValue: data.value.startsAt.minute,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.value.startsAt.minute) = $event)),
                      size: "small",
                      id: "hour-minute-select",
                      style: {"width":"75px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElOption), {
                          label: '00',
                          value: 0,
                          id: "hour-minute-option-0"
                        }),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(59, (n) => {
                          return _createVNode(_unref(ElOption), {
                            key: n,
                            id: 'hour-minute-option-' + n,
                            label: n < 10 ? '0' + n : n,
                            value: n
                          }, null, 8, ["id", "label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (selectedType.value === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_unref(ElRadio), {
                  onChange: onStepChange,
                  modelValue: data.value.dayType,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((data.value.dayType) = $event)),
                  label: "day-every",
                  id: "day-type-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("Schedule.EveryDay")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_11,
                _createVNode(_unref(ElRadio), {
                  onChange: onStepChange,
                  modelValue: data.value.dayType,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((data.value.dayType) = $event)),
                  label: "day-every-weekday",
                  id: "day-type-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("Schedule.EveryWeekday")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_12,
                _createVNode(_unref(ElRadio), {
                  onChange: onStepChange,
                  modelValue: data.value.dayType,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((data.value.dayType) = $event)),
                  label: "day-every-weekend",
                  id: "day-type-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("Schedule.EveryWeekend")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_13,
                _createElementVNode("span", {
                  onChange: onStepChange,
                  class: "font-size-14"
                }, _toDisplayString(_unref(t)("Schedule.StartsAt")) + "  ", 33),
                _createVNode(_unref(ElSelect), {
                  onChange: onStepChange,
                  modelValue: data.value.startsAt.hour,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((data.value.startsAt.hour) = $event)),
                  size: "small",
                  id: "day-time-select",
                  style: {"width":"75px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElOption), {
                      label: '00',
                      value: 0,
                      id: "day-time-option-0"
                    }),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(23, (val) => {
                      return _createVNode(_unref(ElOption), {
                        key: val,
                        id: 'day-time-option-' + val,
                        label: val < 10 ? '0' + val : val,
                        value: val
                      }, null, 8, ["id", "label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createTextVNode(" : "),
                _createVNode(_unref(ElSelect), {
                  onChange: onStepChange,
                  modelValue: data.value.startsAt.minute,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((data.value.startsAt.minute) = $event)),
                  size: "small",
                  id: "day-minute-select",
                  style: {"width":"75px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElOption), {
                      label: '00',
                      value: 0,
                      id: "day-minute-option-0"
                    }),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(59, (n) => {
                      return _createVNode(_unref(ElOption), {
                        key: n,
                        id: 'day-minute-option-' + n,
                        label: n < 10 ? '0' + n : n,
                        value: n
                      }, null, 8, ["id", "label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (selectedType.value === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_unref(ElSelect), {
                  onChange: onStepChange,
                  modelValue: data.value.weeklyList,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((data.value.weeklyList) = $event)),
                  size: "small",
                  multiple: "",
                  id: "week-select",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weekDays), (day) => {
                      return (_openBlock(), _createBlock(_unref(ElOption), {
                        id: 'week-option-' + day.day,
                        key: day.index,
                        label: _unref(t)('Schedule.' + day.day),
                        value: day.index
                      }, null, 8, ["id", "label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("Schedule.StartsAt")) + "  ", 1),
                  _createVNode(_unref(ElSelect), {
                    onChange: onStepChange,
                    modelValue: data.value.startsAt.hour,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((data.value.startsAt.hour) = $event)),
                    size: "small",
                    id: "week-time-select",
                    style: {"width":"75px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElOption), {
                        label: '00',
                        id: "week-time-option-0",
                        value: 0
                      }),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(23, (val) => {
                        return _createVNode(_unref(ElOption), {
                          id: 'week-time-option-' + val,
                          key: val,
                          label: val < 10 ? '0' + val : val,
                          value: val
                        }, null, 8, ["id", "label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createTextVNode(" : "),
                  _createVNode(_unref(ElSelect), {
                    onChange: onStepChange,
                    modelValue: data.value.startsAt.minute,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((data.value.startsAt.minute) = $event)),
                    size: "small",
                    style: {"width":"75px"},
                    id: "week-minute-select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElOption), {
                        label: '00',
                        value: 0,
                        id: "week-minute-option-0"
                      }),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(59, (n) => {
                        return _createVNode(_unref(ElOption), {
                          key: n,
                          id: 'week-minute-option-' + n,
                          label: n < 10 ? '0' + n : n,
                          value: n
                        }, null, 8, ["id", "label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (selectedType.value === 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_unref(ElRadio), {
                  onChange: onStepChange,
                  modelValue: data.value.monthType,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((data.value.monthType) = $event)),
                  label: "month-1",
                  id: "month-type-1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)("Schedule.Day")) + " ", 1),
                    _createVNode(_unref(ElSelect), {
                      onChange: onStepChange,
                      modelValue: data.value.monthlyValue.day.first,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((data.value.monthlyValue.day.first) = $event)),
                      size: "small",
                      id: "month-select-1",
                      style: {"width":"75px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (val) => {
                          return _createVNode(_unref(ElOption), {
                            id: 'month-select-1-option-' + val,
                            key: val,
                            label: val,
                            value: val
                          }, null, 8, ["id", "label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_20, " " + _toDisplayString(_unref(t)("Schedule.OfEvery")) + " ", 1),
                    _createVNode(_unref(ElSelect), {
                      onChange: onStepChange,
                      modelValue: data.value.monthlyValue.day.second,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((data.value.monthlyValue.day.second) = $event)),
                      size: "small",
                      id: "month-select-2",
                      style: {"width":"75px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (val) => {
                          return _createVNode(_unref(ElOption), {
                            key: val,
                            label: val,
                            id: 'month-select-2-option-' + val,
                            value: val
                          }, null, 8, ["label", "id", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_21, " " + _toDisplayString(_unref(t)("Schedule.Month")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_22,
                _createVNode(_unref(ElRadio), {
                  onChange: onStepChange,
                  modelValue: data.value.monthType,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((data.value.monthType) = $event)),
                  label: "month-2",
                  id: "month-type-2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)("Schedule.The")) + " ", 1),
                    _createVNode(_unref(ElSelect), {
                      onChange: onStepChange,
                      modelValue: data.value.monthlyValue.the.first,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((data.value.monthlyValue.the.first) = $event)),
                      size: "small",
                      id: "month-select-3",
                      style: {"width":"100px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (val) => {
                          return (_openBlock(), _createBlock(_unref(ElOption), {
                            id: 'month-select-3-option-' + val.label,
                            key: val.value,
                            label: val.label,
                            value: val.value
                          }, null, 8, ["id", "label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createTextVNode("   "),
                    _createVNode(_unref(ElSelect), {
                      onChange: onStepChange,
                      modelValue: data.value.monthlyValue.the.second,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((data.value.monthlyValue.the.second) = $event)),
                      size: "small",
                      id: "month-select-4"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weekDays), (day) => {
                          return (_openBlock(), _createBlock(_unref(ElOption), {
                            key: day.index,
                            id: 'month-select-option-' + day.day,
                            label: _unref(t)('Schedule.' + day.day),
                            value: day.index
                          }, null, 8, ["id", "label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_24, " " + _toDisplayString(_unref(t)("Schedule.OfEvery")) + " ", 1),
                    _createVNode(_unref(ElSelect), {
                      onChange: onStepChange,
                      modelValue: data.value.monthlyValue.the.third,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((data.value.monthlyValue.the.third) = $event)),
                      id: "month-select-5",
                      size: "small",
                      style: {"width":"75px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (val) => {
                          return _createVNode(_unref(ElOption), {
                            key: val,
                            id: 'month-select-5-option-' + val,
                            label: val,
                            value: val
                          }, null, 8, ["id", "label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(t)("Schedule.StartsAt")) + "  ", 1),
                  _createVNode(_unref(ElSelect), {
                    onChange: onStepChange,
                    modelValue: data.value.startsAt.hour,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((data.value.startsAt.hour) = $event)),
                    size: "small",
                    id: "month-hour-select",
                    style: {"width":"75px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElOption), {
                        label: '00',
                        value: 0,
                        id: "month-hour-option-0"
                      }),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(23, (val) => {
                        return _createVNode(_unref(ElOption), {
                          key: val,
                          id: 'month-hour-option-' + val,
                          label: val < 10 ? '0' + val : val,
                          value: val
                        }, null, 8, ["id", "label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createTextVNode(" : "),
                  _createVNode(_unref(ElSelect), {
                    onChange: onStepChange,
                    modelValue: data.value.startsAt.minute,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((data.value.startsAt.minute) = $event)),
                    size: "small",
                    id: "month-minute-select",
                    style: {"width":"75px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElOption), {
                        label: '00',
                        value: 0,
                        id: "month-minute-option-0"
                      }),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(59, (n) => {
                        return _createVNode(_unref(ElOption), {
                          key: n,
                          id: 'month-minute-option-' + n,
                          label: n < 10 ? '0' + n : n,
                          value: n
                        }, null, 8, ["id", "label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (selectedScheduleMode.value === 'predefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createVNode(_unref(ElDatePicker), {
            onChange: onStepChange,
            size: "small",
            modelValue: scheduleTime.value,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((scheduleTime).value = $event)),
            type: "datetime",
            style: {"width":"100%"},
            placeholder: _unref(t)('Schedule.FirstTime')
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_unref(ElSelect), {
            onChange: onStepChange,
            modelValue: selectedPreset.value,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((selectedPreset).value = $event)),
            id: "default-cron-select",
            placeholder: _unref(t)('Schedule.SelectPeriod'),
            class: "width-100 margin-top-10",
            size: "small"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedulePresets.value, (cron, index) => {
                return (_openBlock(), _createBlock(_unref(ElOption), {
                  id: 'default-cron-option-' + index,
                  key: cron.value,
                  label: cron.label,
                  value: cron.value
                }, null, 8, ["id", "label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    (selectedScheduleMode.value === 'advanced')
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createVNode(_unref(ElInput), {
            id: "advanced-cron-input",
            modelValue: cronExpression.value,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((cronExpression).value = $event)),
            size: "small",
            style: {"width":"100%"},
            placeholder: _unref(t)('Schedule.EnterCronExpression'),
            onInput: _cache[29] || (_cache[29] = ($event: any) => (onStepChange()))
          }, null, 8, ["modelValue", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    (selectedScheduleMode.value === 'advanced' && cronExpressionError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          (errorType.value === 'parts')
            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(t)("Schedule.InvalidCronPartsCount")), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(t)("Schedule.InvalidCronSyntax")), 1))
        ]))
      : _createCommentVNode("", true),
    (selectedScheduleMode.value === 'one_time')
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createVNode(_unref(ElDatePicker), {
            onChange: onStepChange,
            size: "small",
            modelValue: scheduleTime.value,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((scheduleTime).value = $event)),
            type: "datetime",
            style: {"width":"100%"},
            placeholder: _unref(t)('Schedule.ExecutionTime')
          }, null, 8, ["modelValue", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplementalFields.value, (field) => {
      return (_openBlock(), _createElementBlock("div", {
        key: field.name,
        class: "margin-top-10"
      }, [
        _createElementVNode("label", _hoisted_34, _toDisplayString(field.label || field.name), 1),
        (field.type === 'select')
          ? (_openBlock(), _createBlock(_unref(ElSelect), {
              key: 0,
              modelValue: dynamicValues.value[field.name],
              "onUpdate:modelValue": ($event: any) => ((dynamicValues.value[field.name]) = $event),
              class: "width-100",
              size: "small",
              onChange: onStepChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options || [], (option) => {
                  return (_openBlock(), _createBlock(_unref(ElOption), {
                    key: String(option.value),
                    label: String(option.label || option.value),
                    value: option.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"]))
          : (field.type === 'boolean')
            ? (_openBlock(), _createBlock(_unref(ElSwitch), {
                key: 1,
                modelValue: dynamicValues.value[field.name],
                "onUpdate:modelValue": ($event: any) => ((dynamicValues.value[field.name]) = $event),
                "active-color": "#5022a6",
                class: "element-switch-oneteg",
                width: 48,
                onChange: onStepChange
              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
            : (field.type === 'datetime')
              ? (_openBlock(), _createBlock(_unref(ElDatePicker), {
                  key: 2,
                  modelValue: dynamicValues.value[field.name],
                  "onUpdate:modelValue": ($event: any) => ((dynamicValues.value[field.name]) = $event),
                  type: "datetime",
                  class: "width-100",
                  size: "small",
                  onChange: onStepChange
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : (_openBlock(), _createBlock(_unref(ElInput), {
                  key: 3,
                  modelValue: dynamicValues.value[field.name],
                  "onUpdate:modelValue": ($event: any) => ((dynamicValues.value[field.name]) = $event),
                  class: "width-100",
                  size: "small",
                  onInput: onStepChange
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
      ]))
    }), 128)),
    (skipToggleVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("Schedule.SkipIfRunning")), 1),
            _createVNode(_unref(ElTooltip), {
              effect: "custom",
              content: _unref(t)('Schedule.SkipIfRunningTooltip'),
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "info-circle",
                  style: {"cursor":"default","font-size":"12px","color":"#909399"}
                })
              ]),
              _: 1
            }, 8, ["content"])
          ]),
          _createVNode(_unref(ElSwitch), {
            "active-color": "#5022a6",
            id: "schedule-skip-if-running",
            class: "element-switch-oneteg",
            width: 48,
            modelValue: skipIfRunning.value,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((skipIfRunning).value = $event)),
            onChange: onSkipIfRunningChange
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (capabilitiesError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("span", null, _toDisplayString(capabilitiesError.value), 1),
          _createVNode(_unref(ElButton), {
            id: "schedule-capabilities-retry",
            class: "margin-left-10",
            size: "small",
            link: "",
            onClick: syncScheduleTypeCatalog
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Schedule.Retry")), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (normalizationError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(normalizationError.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})